import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';

import {
  GetFunctionQuery,
  GetFunctionResponse,
} from '@hud/portal-dtos/webapp-function.dto';
import { AxiosError } from 'axios';
import { ErrorResponse } from '@hud/portal-dtos/webapp-common.dto';
import { PORTAL_BASE } from '../consts';

export const FUNCTION_ID = 'function';

export default function useFunction(
  functionId?: number,
  params?: GetFunctionQuery,
) {
  const { client, isReady } = useClient();
  return useQuery<GetFunctionResponse, AxiosError<ErrorResponse>>({
    queryKey: [FUNCTION_ID, functionId, params],
    queryFn: async () => {
      const response = await client.get<GetFunctionResponse>(
        `${PORTAL_BASE}/functions/${functionId}`,
        { params },
      );
      return GetFunctionResponse.parse(response.data);
    },
    enabled: functionId !== undefined && isReady,
    retry: (failureCount, error) => {
      if (
        error?.response?.status &&
        error.response.status > 401 &&
        error.response.status < 500
      ) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
